import React from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { PostLaunchTruth } from './components/PostLaunchTruth';
import { InvisibleReaders } from './components/InvisibleReaders';
import { GenericNextSteps } from './components/GenericNextSteps';
import { MechanismVisual } from './components/MechanismVisual';
import { ReaderValue } from './components/ReaderValue';
import { BusinessValue } from './components/BusinessValue';
import { Offer } from './components/Offer';
import { FinishFaqCta } from './components/FinishFaqCta';
import { Footer } from './components/Footer';
import { StickyWidget } from './components/StickyWidget';
import { Diagnostic } from './components/Diagnostic';
import { ScoreProvider } from './components/ScoreContext';
export function App() {
  return <ScoreProvider data-id="element-0" data-mp="28tmej1rry8wp">
      <div className="min-h-screen bg-paper font-sans text-text selection:bg-seaglass selection:text-white" data-id="element-1" data-mp="28t4jg8gum0qd">
        <Nav data-id="element-2" data-mp="23v2rey1g2r2r" />
        <main data-id="element-3" data-mp="23t8gmcjw0fce">
          <Hero data-id="element-4" data-mp="3ijxqiu0iq6lh" />
          <PostLaunchTruth data-id="element-5" data-mp="3ikh7o8icgqyg" />
          <InvisibleReaders data-id="element-6" data-mp="3ij64a9st9l7v" />
          <GenericNextSteps data-id="element-7" data-mp="3ihv2ugmu8pjx" />
          <MechanismVisual data-id="element-8" data-mp="3mlaxx8j9ehui" />
          <ReaderValue data-id="element-9" data-mp="3mkhn9wh6j873" />
          <BusinessValue data-id="element-10" data-mp="3mjq1fdddwou0" />
          <Offer data-id="element-11" data-mp="3mj6lg27aoaim" />
          <FinishFaqCta data-id="element-12" data-mp="3rcj31sdk3h1v" />
        </main>
        <Footer data-id="element-13" data-mp="3rdkkqfp2v1sk" />
        <StickyWidget data-id="element-14" data-mp="3rd189ei755lx" />
        <Diagnostic data-id="element-15" data-mp="5yj0slx59ec" />
      </div>
    </ScoreProvider>;
}